module.exports = __webpack_public_path__ + "img/export.e98af10d.svg";